import { useMemo } from "react";
import type { NurseResponse } from "@vTypes/nurse-type";
import type { PreceptorGroupID } from "@vTypes/roster.types";
import { filterPreceptorList } from "@utils/filter-preceptorlist";

const EMPTY_NURSES: NurseResponse[] = [];

export function usePreceptorMapping(fullNurseSchema?: NurseResponse[] | null) {
  const nurses = fullNurseSchema ?? EMPTY_NURSES;

  const preceptorGroupID: PreceptorGroupID[] = useMemo(() => {
    const preceptorMap = new Map<string, string[]>();

    nurses.forEach((nurse) => {
      const preceptorID = nurse.preceptor_id;
      const nurseID = nurse.nurse_id;
      if (preceptorID) {
        if (!preceptorMap.has(preceptorID)) {
          preceptorMap.set(preceptorID, []);
        }
        preceptorMap.get(preceptorID)!.push(nurseID);
      }
    });

    return Array.from(preceptorMap.entries()).map(([preceptor, preceptee]) => ({
      preceptor,
      preceptee,
    }));
  }, [nurses]);

  const preceptorList = useMemo(
    () => filterPreceptorList(nurses, preceptorGroupID),
    [nurses, preceptorGroupID]
  );

  return { preceptorGroupID, preceptorList };
}
